import countActiveFilters from 'Utils/countActiveFilters'
import { EMPTY_OBJECT } from 'Utils/stableDefaults'

// The "More Filters" badge counts only the filters that live inside the More Filters panel at the
// current breakpoint - wider breakpoints surface more filters in the main bar, so fewer remain here.
// Shared by RemainingFilters (the loaded dropdown/overlay) and LazyRemainingFilters (the pre-load
// trigger) so the count stays identical whether or not the heavy module has been imported.
function getActiveFilterCount({
  selectedFilters = EMPTY_OBJECT,
  currentBreakpoint,
  subscriptionFlowEnabled = false,
}) {
  const {
    fileTypesActiveFiltersCount,
    licensesActiveFiltersCount,
    metaverseActiveFiltersCount,
    modelTypeActiveFiltersCount,
    polygonsActiveFiltersCount,
    priceRangeActiveFiltersCount,
    pricingActiveFiltersCount,
    miscellaneousActiveFiltersCount,
    designersActiveFiltersCount,
  } = countActiveFilters(selectedFilters)

  // Count designers when Following lives inside More Filters:
  // - At xs: button in ALL FILTERS modal
  // - Any breakpoint when subscriptionFlowEnabled (moved from main bar)
  const designersCount = (
    currentBreakpoint === 'xs' || subscriptionFlowEnabled
  ) ? designersActiveFiltersCount : 0

  if (['xxl', 'xl'].includes(currentBreakpoint)) {
    return (
      licensesActiveFiltersCount +
      metaverseActiveFiltersCount +
      miscellaneousActiveFiltersCount +
      designersCount
    )
  }

  if (['lg', 'md'].includes(currentBreakpoint)) {
    return (
      licensesActiveFiltersCount +
      metaverseActiveFiltersCount +
      miscellaneousActiveFiltersCount +
      polygonsActiveFiltersCount +
      designersCount
    )
  }

  if (currentBreakpoint === 'sm') {
    return (
      licensesActiveFiltersCount +
      metaverseActiveFiltersCount +
      miscellaneousActiveFiltersCount +
      polygonsActiveFiltersCount +
      priceRangeActiveFiltersCount +
      pricingActiveFiltersCount +
      designersCount
    )
  }

  if (currentBreakpoint === 'xs') {
    return (
      licensesActiveFiltersCount +
      metaverseActiveFiltersCount +
      miscellaneousActiveFiltersCount +
      polygonsActiveFiltersCount +
      priceRangeActiveFiltersCount +
      pricingActiveFiltersCount +
      fileTypesActiveFiltersCount +
      modelTypeActiveFiltersCount +
      designersCount
    )
  }

  return 0
}

export default getActiveFilterCount
